import { useState, useEffect, Dispatch, SetStateAction } from 'react';

/**
 * 
 * @param props 
 * @key - 재발송 누르면 타이머 초기화용
 * @setIsTimeOut - 시간 다되면 true 리턴
 * @returns 
 */

interface TimerType {
    isTimeOut: boolean
    setIsTimeOut: Dispatch<SetStateAction<boolean>>
    timerKey: number
}

const Timer = ({ timerKey, isTimeOut, setIsTimeOut }: TimerType) => {
    const [remainingTime, setRemainingTime] = useState<number>(600); // 10분을 초 단위로 설정

    useEffect(() => {
        setRemainingTime(600);
        const interval = setInterval(() => {
            setRemainingTime(prevTime => {
                if (prevTime > 0) {
                    return prevTime - 1; // 1초씩 감소
                }
                else {
                    clearInterval(interval); // 타이머를 멈춤
                    return 0;
                }
            });
        }, 1000);

        return () => clearInterval(interval); // 컴포넌트가 언마운트될 때 타이머를 정리
    }, [timerKey]); // 빈 배열을 전달하여 이펙트가 처음에만 실행되도록 함

    useEffect(() => {
        if (remainingTime <= 0) {
            setIsTimeOut(true)
            console.log('시간초과???')
        }
    }, [remainingTime])

    // 남은 시간을 분:초 형태로 변환하는 함수
    const formatTime = (time: number) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    return (
        <div>
            <p className={`${isTimeOut ? 'text-red' : 'text-black'}`}>
                {formatTime(remainingTime)}
            </p>
        </div>
    );
};

export default Timer;
